import { useCallback, useEffect, useState } from 'react'
import { useStreetsQuery } from '../../../../api/options/hooks'
import { Step5FormProps, Step5FormStreetProps } from '../types'

const useStep5FormStreet = (form: Step5FormProps['form']): Step5FormStreetProps => {
    const city = form.watch('invoiceAddressCity')
    const zip = form.watch('invoiceAddressZIP')
    const street = form.watch('invoiceAddressCity')
    const [streetSearch, setStreetSearch] = useState<string | undefined>(street)
    const handleStreetSearchChanged = useCallback((s: string) => setStreetSearch(s), [])
    useEffect(() => {
        setStreetSearch(street)
    }, [street])

    const { data, isLoading } = useStreetsQuery(streetSearch, city, zip)

    return {
        streetSearch,
        handleStreetSearchChanged,
        streets: data || [],
        isLoading,
    }
}

export default useStep5FormStreet
